<template>
  <div class="hello">
   <p class="good">本平台是由游卡设立的原创桌游设计投稿专用平台，长期面向原创桌游设计师及热心桌游玩家开放并接受投稿，我们的优势主要包括：</p>
   <p class="home-img">
      <img src="../assets/img/mine1.jpg" alt="" />
      <img src="../assets/img/mine2.jpg" alt="" />
      <img src="../assets/img/mine3.jpg" alt="" />
      <img src="../assets/img/mine4.jpg" alt="" />
      <img src="../assets/img/mine5.jpg" alt="" />
   </p>
   <p class="content">无论你是经验老道的专业设计师，还是怀抱一腔热血与激情的桌游爱好者，只要你有更好的创意以及实践的决心，就可以在这里把你的创意变成真正的桌面游戏，把你的快乐与喜悦传递给更多的玩家！</p>
  </div>
</template>

<script>
export default {
  name: 'home',
   data(){
  	return{
  	}
  },
  methods:{
  	handleSelect(){
  		
  	}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.hello{
		padding-top: 270px;
		width: 1000px;
		/*border: 1px solid  green;*/
		margin: 0 auto; line-height: 26px;
	}
	.hello .good{
		width: 1000px;
		text-align: center; margin-bottom: 33px;
	}
	.hello .content{
		padding-bottom: 100px;
	}
  .home-img img{ display: block; margin: 0 auto 35px; }
</style>



// WEBPACK FOOTER //
// src/views/home.vue